import { Preview } from '@hb/shared'
import { useCallback, useState } from 'react'

export const usePreview = () => {
  const [preview, setPreview] = useState<Preview | null>(null)

  const openPreview = useCallback((p: Preview) => {
    setPreview(p)
  }, [])

  const closePreview = useCallback(() => {
    if (!preview) return
    setPreview(null)
  }, [preview])
  return {
    preview,
    closePreview,
    openPreview,
  }
}
